import { type ChallengeConfig } from '../../challenge-configs-api.ts';
import { type PerformanceGameRow } from '../performance-api.ts';
import { getGameName } from './sessions.ts';
import { type SessionsServiceSession } from './sessions-service-api.ts';
import { sumTotals } from './totals.ts';

export const buildGames = (
  completed: SessionsServiceSession[],
  configsById: Map<number, ChallengeConfig>
): PerformanceGameRow[] => {
  const sessionsByConfig = new Map<number, SessionsServiceSession[]>(
    [...configsById.keys()].map((id) => [id, []])
  );

  completed.forEach((session) => {
    const id = session.challenge_config_id;
    const group = sessionsByConfig.get(id);
    if (group) group.push(session);
    else sessionsByConfig.set(id, [session]);
  });

  return [...sessionsByConfig.entries()]
    .map(([configId, sessions]) => {
      const config = configsById.get(configId);
      return {
        ...sumTotals(sessions),
        config_id: configId,
        name: config?.display_name ?? getGameName(sessions[0], configsById),
        mode: config?.mode ?? null,
      };
    })
    .sort((a, b) => b.sessions - a.sessions || a.name.localeCompare(b.name));
};
